import styled from 'styled-components';

export default styled.div`
  width: 8rem;
  display: inline-block;
  position: relative;
  height: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  background: rgb(81 81 81);
  border-radius: 1rem;
  overflow: hidden;
  cursor: pointer;
  z-index: 1;
`;
